/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import {
  COMMAND_INTELLIGENCE_BY_LOCALE,
  DEFAULT_COMMAND_INTELLIGENCE_LOCALE,
} from '../../../messages/commandIntelligence/index.js';

const getCommandIntelligenceDefaults = locale =>
  COMMAND_INTELLIGENCE_BY_LOCALE[locale] ?? COMMAND_INTELLIGENCE_BY_LOCALE[DEFAULT_COMMAND_INTELLIGENCE_LOCALE];

/** Merge locale-specific CDS commandIntelligence defaults into a single locale catalog. */
export const mergeCdsDefaultMessagesForLocale = (locale, localeMessages = {}) => ({
  ...getCommandIntelligenceDefaults(locale),
  ...localeMessages,
});

/** Locale-keyed message maps from ConnexDesignSystem / Localization. */
export const mergeCdsDefaultMessages = messages => {
  if (!messages || typeof messages !== 'object') {
    return messages;
  }

  return Object.keys(messages).reduce((acc, locale) => {
    acc[locale] = mergeCdsDefaultMessagesForLocale(locale, messages[locale]);

    return acc;
  }, {});
};
